import React, { useEffect, useState } from 'react';
import { GetRequest, PostRequest } from 'components/common/index.js';
import UpdatePaymentMethod from 'components/payment/UpdatePaymentMethod.jsx';
import UpgradeToAnnualModal from 'components/payment/UpgradeToAnnualModal.jsx';

const MySubscription = ({ link_to_manage }) => {

  const [subscriptionDescription, setSubscriptionDescription] = useState('');
  const [nextPaymentDate, setNextPaymentDate] = useState('');
  const [nextPaymentAmount, setNextPaymentAmount] = useState('');
  const [per, setPer] = useState('');
  const [isPayPal, setIsPayPal] = useState(false);
  const [isStripe, setIsStripe] = useState(false);
  const [willRenew, setWillRenew] = useState(false);
  const [pastDue, setPastDue] = useState(false);
  const [canUpgradeToAnnual, setCanUpgradeToAnnual] = useState(false);
  const [annualSaving, setAnnualSaving] = useState('');
  const [stripePaymentId, setStripePaymentId] = useState('');
  const [paymentMethodName, setPaymentMethodName] = useState('');
  const [stripeCustomerId, setStripeCustomerId] = useState('');
  const [stripeSubscriptionId, setStripeSubscriptionId] = useState('');
  const [currency, setCurrency] = useState('');
  const [loading, setLoading] = useState(true);
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);

  const getMySubscription = () => {
    GetRequest({
      url: '/charge/my-subscription',
      callback: (data) => {
        setLoading( () => false );
       if(data.subscription != undefined && data.subscription != '' && data.subscription != null) {

        if (data.subscription.is_paypal) {
          isPayPal(() => true)
        }

        if(data.subscription.is_stripe) {
          setIsStripe( () => true);
          setWillRenew( () => data.subscription.will_renew);
          setSubscriptionDescription( () => data.subscription.description);
          setNextPaymentDate( () => data.subscription.next_payment_date);
          setNextPaymentAmount( () => data.subscription.next_payment_amount);
          setPastDue( () => data.subscription.past_due);
          setCanUpgradeToAnnual( () => data.subscription.can_upgrade_to_annual);
          setAnnualSaving( () => data.subscription.annual_price_saving_formatted);
          setStripePaymentId( () => data.subscription.stripe_payment_method_id);
          setStripeSubscriptionId( () => data.subscription.stripe_subscription_id);
          setStripeCustomerId( () => data.subscription.stripe_customer_id);
          setPaymentMethodName( () => data.subscription.payment_method_name);
          setCurrency( () => data.subscription.currency);
          if(data.subscription.subscription_type == 'monthly' )  { setPer( () => t('sign_up.per_month')  ) }
          if(data.subscription.subscription_type == 'annually' ) { setPer( () => t('sign_up.per_year')  ) }
        }

       }
      }
    })
  }

  useEffect( getMySubscription, []);

  if(loading) {
    return (
      <div className="subscription-card subscription-card-skeleton" aria-busy="true" aria-label={t('sign_up.fetching_subscription_please_wait')}>
        <div className="subscription-card-icon" aria-hidden="true">
          <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" fill="none">
            <rect x="10" y="26" width="50" height="36" rx="5" fill="#ffffff" />
            <rect x="10" y="32" width="50" height="5" fill="rgba(0,0,0,0.18)" />
            <rect x="16" y="44" width="10" height="7" rx="1.5" fill="#eb5424" opacity="0.7" />
            <circle cx="32" cy="55" r="1.6" fill="#eb5424" opacity="0.55" />
            <circle cx="37" cy="55" r="1.6" fill="#eb5424" opacity="0.55" />
            <circle cx="42" cy="55" r="1.6" fill="#eb5424" opacity="0.55" />
            <circle cx="47" cy="55" r="1.6" fill="#eb5424" opacity="0.55" />
            <circle cx="60" cy="22" r="14" fill="#ffffff" />
            <path d="M 60 14 A 8 8 0 1 1 52 22" fill="none" stroke="#eb5424" strokeWidth="3.5" strokeLinecap="round" />
            <polygon points="52,12 47,21 57,21" fill="#eb5424" />
          </svg>
        </div>
        <div className="subscription-card-body">
          <div className="subscription-skeleton-row subscription-skeleton-row-between">
            <div>
              <div className="subscription-skeleton-line subscription-skeleton-line-label" />
              <div className="subscription-skeleton-line subscription-skeleton-line-plan" />
            </div>
            <div className="subscription-skeleton-line subscription-skeleton-line-price" />
          </div>
          <div className="subscription-skeleton-divider" />
          <div className="subscription-skeleton-row">
            <div className="subscription-skeleton-line subscription-skeleton-line-meta" />
            <div className="subscription-skeleton-line subscription-skeleton-line-meta" />
          </div>
        </div>
      </div>
    )
  }

  if(!isPayPal && !isStripe) {
    return ''
  }

  if(isPayPal) {
    return <>
      <p> {t("sign_up.subscription_managed_on_paypal")} </p> <br />
      <p> {t("sign_up.cancel_on_paypal")} </p>
    </>
  }

  return (
    <>
      {pastDue && (
        <div className="alert alert-warning subscription-past-due-alert">
          <span dangerouslySetInnerHTML={{__html: t("sign_up.subscription_past_due")}} ></span>
        </div>
      )}

      <div className="subscription-card">
        <div className="subscription-card-icon" aria-hidden="true">
          <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" fill="none">
            <rect x="10" y="26" width="50" height="36" rx="5" fill="#ffffff" />
            <rect x="10" y="32" width="50" height="5" fill="rgba(0,0,0,0.18)" />
            <rect x="16" y="44" width="10" height="7" rx="1.5" fill="#eb5424" opacity="0.7" />
            <circle cx="32" cy="55" r="1.6" fill="#eb5424" opacity="0.55" />
            <circle cx="37" cy="55" r="1.6" fill="#eb5424" opacity="0.55" />
            <circle cx="42" cy="55" r="1.6" fill="#eb5424" opacity="0.55" />
            <circle cx="47" cy="55" r="1.6" fill="#eb5424" opacity="0.55" />
            <circle cx="60" cy="22" r="14" fill="#ffffff" />
            <path d="M 60 14 A 8 8 0 1 1 52 22" fill="none" stroke="#eb5424" strokeWidth="3.5" strokeLinecap="round" />
            <polygon points="52,12 47,21 57,21" fill="#eb5424" />
          </svg>
        </div>

        <div className="subscription-card-body">
          <div className="subscription-card-header">
            <div className="subscription-card-title">
              <span className="subscription-card-label">{t('nav.my_subscription')}</span>
              {subscriptionDescription && (
                <h4 className="subscription-card-plan">{subscriptionDescription}</h4>
              )}
            </div>
            {nextPaymentAmount && (
              <div className="subscription-card-price">
                <span className="subscription-card-amount">{nextPaymentAmount}</span>
                {per && <span className="subscription-card-period"> / {per}</span>}
              </div>
            )}
          </div>

          <div className="subscription-card-meta">
            {!willRenew && (
              <span className="subscription-card-meta-item subscription-card-meta-warning">
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                {t('nav.subscription_will_not_be_renewed')}
              </span>
            )}
            {!pastDue && willRenew && nextPaymentDate && (
              <span className="subscription-card-meta-item">
                <i className="fa fa-calendar-o" aria-hidden="true"></i>
                <strong>{t('sign_up.next_payment_date')}</strong> {nextPaymentDate}
              </span>
            )}
            {paymentMethodName && (
              <span className="subscription-card-meta-item">
                <i className="fa fa-credit-card" aria-hidden="true"></i>
                {paymentMethodName}
              </span>
            )}
            {canUpgradeToAnnual && annualSaving && (
              <a
                className="subscription-card-upgrade-link"
                href="#"
                onClick={(event) => { event.preventDefault(); setUpgradeModalOpen(true); }}
              >
                {t('sign_up.change_to_annual_cta')}
                <span className="subscription-card-upgrade-link-saving">
                  <i className="fa fa-tag" aria-hidden="true"></i>
                  <span dangerouslySetInnerHTML={{__html: t("sign_up.save_per_year").replace('%{saving}', annualSaving)}} ></span>
                </span>
              </a>
            )}
          </div>

          {stripePaymentId && (
            <div className="subscription-card-actions">
              <UpdatePaymentMethod stripeCustomerId={stripeCustomerId} stripeSubscriptionId={stripeSubscriptionId} currency={currency} />
              {link_to_manage && (
                <a className="btn subscription-card-action-secondary" href="/my_subscriptions">
                  {t('payment.manage_subscription')}
                </a>
              )}
            </div>
          )}
        </div>
      </div>

      {upgradeModalOpen && (
        <UpgradeToAnnualModal
          onClose={() => setUpgradeModalOpen(false)}
          onSuccess={() => { setUpgradeModalOpen(false); getMySubscription(); }}
        />
      )}
    </>
  )
}

export default MySubscription;
